export default __webpack_public_path__ + "static/media/banner2.75c0ac2d.jpg";